import React, { useEffect, useState }   from "react";
import {Link}                           from "react-router-dom";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";

import "./blogs.scss";

import {OmniSearchCarousel} from "../../omni-search-carousel/omni-search-carousel";
import {Shimmer}            from "../../common/shimmer/shimmer";


const WIDTH_COMPONENT = 294
const EDGE_ITEM_DIVISOR = 6

export const Blogs = ({blogPosts}) => {
    const url = window.location.href
    const app = '/app'
    const urlBlog = url.split(app)[0] + '/s/blog/'

    if(!Array.isArray(blogPosts)) {
        return null
    }

    if(blogPosts.length < 1) {
        return null
    }
    
    return (
        <div className="blogs-tm0r5">
            <div className="blogs-container">
                <div className="heading">
                    <p className="heading-text">
                        Blog
                    </p>
                    <a
                        className="icon-link"
                        target="_blank"
                        href={urlBlog}
                    >
                        <FontAwesomeIcon
                            icon={require('@fortawesome/free-solid-svg-icons')['faChevronRight']}
                            className='icon-chevron'
                        />
                    </a>
                </div>
                <div className="results">
                    <p className="results-text">
                        {`${blogPosts.length === 1 ? '1 RESULT' : blogPosts.length + ' RESULTS'}`}
                    </p>
                    <a
                        className="see-all"
                        target="_blank"
                        href={urlBlog}
                    >
                        See All
                    </a>
                </div>
                <OmniSearchCarousel
                    Component={Blog}
                    items={blogPosts}
                    widthComponent={WIDTH_COMPONENT}
                    edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                    additionalProps={{urlBlog}}
                />
            </div>
        </div>
    )
}

const Blog = ({item, urlBlog}) => {
    const [thumbnailLoaded, setThumbnailLoaded] = useState(false)
    const blog = item
    const thumbnail = blog?.thumbnail ? blog.thumbnail : ''

    const category = (Array.isArray(blog.categories) && blog.categories.length > 0) 
                   ? blog.categories[0].toUpperCase() 
                   : ' '
  
    return (
        <a
            className="blog-p0stv76"
            target="_blank"
            href={`${urlBlog}${blog.slug}`}
        >
            {!thumbnailLoaded && <Shimmer name={"image-container"} />}
            {
                <div 
                    className="image-container"
                    style={{display: thumbnailLoaded ? 'flex' : 'none'}}
                >
                    <img 
                        src={thumbnail}
                        alt={`image-${blog.slug}`}
                        onLoad={() => setThumbnailLoaded(true)}
                    />
                </div>
            }
            <div className="details">
                <div className="category">
                    <p className="category-text">
                        {category}
                    </p>
                </div>
                <div className="title">
                    <p className="title-text">
                        {blog.title}
                    </p>
                </div>
                <div className="excerpt">
                    <p className="excerpt-text">
                        {blog.excerpt}
                    </p>
                </div>
            </div>
        </a>
    )

}